import React from "react";

const StickyApplyBar = ({ title }) => {
  return (
    <div className="position-sticky bottom-0 start-0 end-0 bg-white border-top" style={{ zIndex: 1020 }}>
      <div className="container py-2 d-flex justify-content-between align-items-center">
        <div className="small text-muted text-truncate">{title}</div>
        <a href="#apply" className="btn btn-success btn-sm">Apply for this job</a>
      </div>
    </div>
  );
};

export default StickyApplyBar;
